import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
import type { AdType } from '../../type';

/**
 * @description Fallback-заглушка рекламы для окружений где AdSense не отдаёт контент
 * (staging, dev, неодобренные домены). Позволяет тестировать весь поток просмотра рекламы.
 */
export const AdFallbackPlaceholder: FC<{
  adType: AdType;
}> = t0 => {
  const $ = _c(13);
  const {
    adType
  } = t0;
  let t1;
  if ($[0] !== adType) {
    t1 = <div className="rounded-full bg-[#ff6b00]/20 px-4 py-1.5"><span className="text-sm font-medium text-[#ff6b00]">Ad Preview — {adType}</span></div>;
    $[0] = adType;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== adType) {
    t2 = <div className="flex h-24 w-24 items-center justify-center rounded-2xl bg-white/5">{adType === "video" ? <svg className="h-12 w-12 text-white/40" fill="none" stroke="currentColor" viewBox="0 0 24 24"><title>Video ad</title><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg> : <svg className="h-12 w-12 text-white/40" fill="none" stroke="currentColor" viewBox="0 0 24 24"><title>Banner ad</title><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>}</div>;
    $[2] = adType;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = adType === "video" ? "Video Ad Placeholder" : "Banner Ad Placeholder";
  let t4;
  if ($[4] !== t3) {
    t4 = <p className="text-lg font-medium text-white/70">{t3}</p>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <p className="max-w-sm text-sm text-white/40">AdSense не отдал контент для этого домена. Поток продолжает работать в штатном режиме — таймер тикает, награда будет начислена.</p>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4) {
    t6 = <div className="flex flex-col items-center gap-2 text-center">{t4}{t5}</div>;
    $[7] = t4;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t1 || $[10] !== t2 || $[11] !== t6) {
    t7 = <div className="flex h-full w-full flex-col items-center justify-center gap-6 bg-gradient-to-br from-[#1a1a2e] to-[#2a2a3e] p-8">{t1}{t2}{t6}</div>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};